import {
  ServerLiabilityFetch,
  Liability,
  ClearLiabilityErrorAction,
  CreateLiabilityAction,
  CreateLiabilityFailAction,
  CreateLiabilitySuccessAction,
  DeleteLiabilityAction,
  DeleteLiabilityFailAction,
  DeleteLiabilitySuccessAction,
  FetchLiabilitiesAction,
  FetchLiabilitiesFailAction,
  FetchLiabilitiesSuccessAction,
  SetLiabilityErrorAction,
  UpdateLiabilitiesAction,
  UpdateLiabilitiesFailAction,
  UpdateLiabilitiesAbortAction,
  UpdateLiabilitiesSuccessAction,
  UpsertLiabilitiesAction,
  UpsertLiabilitiesFailAction,
  UpsertLiabilitiesSuccessAction,
} from '@funnels/types';
import { REDUX_STORE } from '@funnels/constants';

export function clearLiabilityError(): ClearLiabilityErrorAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.CLEAR_LIABILITY_ERROR };
}

export function createLiability(applicationId: string, liability: Liability): CreateLiabilityAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.CREATE_LIABILITY, applicationId, liability };
}

export function createLiabilityFail(clientId: string): CreateLiabilityFailAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.CREATE_LIABILITY_FAIL, clientId };
}

export function createLiabilitySuccess(clientId: string, id: string, assetId: string[]): CreateLiabilitySuccessAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.CREATE_LIABILITY_SUCCESS, clientId, id, assetId };
}

export function deleteLiability(applicationId: string, clientId: string, id?: string): DeleteLiabilityAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.DELETE_LIABILITY, applicationId, clientId, id };
}

export function deleteLiabilityFail(clientId: string): DeleteLiabilityFailAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.DELETE_LIABILITY_FAIL, clientId };
}

export function deleteLiabilitySuccess(): DeleteLiabilitySuccessAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.DELETE_LIABILITY_SUCCESS };
}

export function fetchLiabilities(applicationId: string): FetchLiabilitiesAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.FETCH_LIABILITIES, applicationId };
}

export function fetchLiabilitiesFail(): FetchLiabilitiesFailAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.FETCH_LIABILITIES_FAIL };
}

export function fetchLiabilitiesSuccess(liabilities: ServerLiabilityFetch[]): FetchLiabilitiesSuccessAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.FETCH_LIABILITIES_SUCCESS, liabilities };
}

export function setLiabilityError(message: string = 'Unknown error'): SetLiabilityErrorAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.SET_LIABILITY_ERROR, message };
}

export function updateLiability(applicationId: string, liability: Liability): UpdateLiabilitiesAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.UPDATE_LIABILITY, applicationId, liability };
}

export function updateLiabilityFail(clientId: string): UpdateLiabilitiesFailAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.UPDATE_LIABILITY_FAIL, clientId };
}

export function updateLiabilityAbort(): UpdateLiabilitiesAbortAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.UPDATE_LIABILITY_ABORT };
}

export function updateLiabilitySuccess(clientId: string, assetId: string[]): UpdateLiabilitiesSuccessAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.UPDATE_LIABILITY_SUCCESS, clientId, assetId };
}

export function upsertLiabilities(applicationId: string, liabilities: Liability[]): UpsertLiabilitiesAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.UPSERT_LIABILITIES, applicationId, liabilities };
}

export function upsertLiabilitiesFail(): UpsertLiabilitiesFailAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.UPSERT_LIABILITIES_FAIL };
}

export function upsertLiabilitiesSuccess(): UpsertLiabilitiesSuccessAction {
  return { type: REDUX_STORE.LIABILITIES.ACTION_TYPES.UPSERT_LIABILITIES_SUCCESS };
}
